import Vue from 'vue'
import App from './App.vue'
import store from './store'


Vue.config.productionTip = false
window.axios = require('axios');



var el = document.getElementById("integrationTest");
let dynamic = false;
let settings;
if(el.dataset.settings != "" && el.dataset.dynamiccatpage) {
  settings = JSON.parse(el.dataset.settings)
  settings.showCat = [el.dataset.dynamiccatpage]
  dynamic = true;
} else {
  settings = JSON.parse(el.dataset.settings);
}
window.shopPageObj = new Vue({
  store,
  name: "IntegrationsTestv2",
  data: {
    backorder: Boolean(el.dataset.backorder),
    settings: el.dataset.settings != "" ? settings : {"showFilter": true, "defaultView": "list", "showCat": [], "hideCat": [],"imageView":"M"},
    contentid: el.dataset.contentid,
    language: webshopLang,
    pointshop: (el.dataset.pointshop == "Y"),
    isTurquoisePointshop:(el.dataset.isturquoise == "Y"),
    webhost: el.dataset.webhost,
    basedir: basedir,
    subscriptionenabled: (el.dataset.subscriptionenabled == "true"),
    messenger: (el.dataset.messenger == 'Y'),
    pageid: el.dataset.pageid,
    pointvision: (el.dataset?.pointvision == 'true'),
    pointshopUrlPrefix: el.dataset.pointshopurlprefix+"/",
    admin: el.dataset.admin,
    dynamiccatpage: dynamic,
    localadmin: el.dataset.localadmin == "true" ? true : false,
    display: JSON.parse(el.dataset.display),
    flaptype: el.dataset.settings && (JSON.parse(el.dataset.settings)?.imageView)? JSON.parse(el.dataset.settings).imageView : el.dataset.flaptype,
    globalflaptype: (el.dataset.flaptype)
  },
  render: h => h(App)
}).$mount('#integrationTest')
